module.exports = __webpack_public_path__ + "img/application-o.f6581baa.svg";